import _ from 'lodash';
import moment from 'moment';

import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  WORKER_IMAGE_REGISTER_STATUS,
  WORKER_IMAGE_CCUS_SYNCED_STATUS,
  SORT_TYPE,
  WORKER_DISTINCT_STATUS,
  FIELD_TREE_WORKER_CCUS_SYNCED_STATUS,
  CCUS_ENGINEER_ID_STATUS,
  CONNECT_WORK_HISTORY_STATUS,
  WORKER_SETTING_STATUS,
  DATE_TIME_FORMAT,
} from '../../utilities/constants';
import PrintUtility from '../../utilities/printUtility';

/**
 * 検索用パラメータを作成
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchWorkerSettingList = (param, blacklistSearchKeys) => {
  const searchParam = Object.create(null);
  searchParam.offset = param.offset;
  searchParam.limit = param.limit;

  if (!_.isEmpty(param.fieldTreeIds)) {
    searchParam.field_tree_ids = _.map(param.fieldTreeIds, Number);
  }

  if (!_.isEmpty(param.companyIds)) {
    searchParam.primary_company_ids = _.map(param.companyIds, Number);
  }
  // BLDE_V2-42611  連携状態の検索パラメータ
  if (!_.isEmpty(param.fieldTreeWorkerCcusSyncedStatusList)) {
    searchParam.field_tree_worker_ccus_synced_status =
      param.fieldTreeWorkerCcusSyncedStatusList;
  }
  if (!isNullOrEmpty(param.workerName)) {
    searchParam.worker_name = String(param.workerName);
  }
  // BLDE_V2-50576 CCUS事業者ID削除されたかどうかパラメータ
  if (!isNullOrEmpty(param.ccusJigyousyaDeleted)) {
    searchParam.ccus_jigyousya_deleted_flag = param.ccusJigyousyaDeleted;
  }

  // 『workerImage』は現場設定ページで使用している
  // 現場設定ページのプロパティ名を変更できる機会があれば変更する
  if (
    !isSelectAllCheckbox(
      param.workerImageRegisterStatusList,
      WORKER_IMAGE_REGISTER_STATUS
    ) &&
    !_.isEmpty(param.workerImageRegisterStatusList)
  ) {
    searchParam.worker_image_register_status = Number(
      param.workerImageRegisterStatusList[0].id
    );
  } else if (!isNullOrEmpty(param.workerImage)) {
    searchParam.worker_image_register_status = Number(param.workerImage);
  }

  // 『registerStatus』は現場設定ページで使用している
  // 現場設定ページのプロパティ名を変更できる機会があれば変更する
  if (
    !isSelectAllCheckbox(
      param.workerImageCcusSyncedStatusList,
      WORKER_IMAGE_CCUS_SYNCED_STATUS
    )
  ) {
    searchParam.worker_image_ccus_synced_status = _.map(
      param.workerImageCcusSyncedStatusList,
      'id'
    );
  } else if (!isNullOrEmpty(param.registerStatus)) {
    searchParam.worker_image_ccus_synced_status = Number(param.registerStatus);
  }

  // 『hasError』は現場設定ページで使用している
  // 現場設定ページのプロパティ名を変更できる機会があれば変更する
  if (!_.isEmpty(param.hasErrorList)) {
    searchParam.worker_image_has_error = Number(param.hasErrorList[0].id);
  } else if (!isNullOrEmpty(param.hasError)) {
    searchParam.worker_image_has_error = Number(param.hasError);
  }

  searchParam.field_tree_worker_ccus_synced_status = _.map(
    isSelectAllCheckbox(
      param.fieldTreeWorkerCcusSyncedStatusList,
      FIELD_TREE_WORKER_CCUS_SYNCED_STATUS
    )
      ? FIELD_TREE_WORKER_CCUS_SYNCED_STATUS
      : param.fieldTreeWorkerCcusSyncedStatusList,
    'ID'
  );

  searchParam.worker_status = _.map(
    isSelectAllCheckbox(param.workerSettingStatusList, WORKER_SETTING_STATUS)
      ? WORKER_SETTING_STATUS
      : param.workerSettingStatusList,
    'ID'
  );

  if (
    !isSelectAllCheckbox(
      param.fieldCcusEngineerIdStatus,
      CCUS_ENGINEER_ID_STATUS
    ) &&
    !_.isEmpty(param.fieldCcusEngineerIdStatus)
  ) {
    searchParam.field_ccus_engineer_id_status = Number(
      param.fieldCcusEngineerIdStatus[0].ID
    );
  }

  if (
    !isSelectAllCheckbox(
      param.fieldConnectWorkHistoryStatus,
      CONNECT_WORK_HISTORY_STATUS
    ) &&
    !_.isEmpty(param.fieldConnectWorkHistoryStatus)
  ) {
    searchParam.field_connect_work_history_status = Number(
      param.fieldConnectWorkHistoryStatus[0].ID
    );
  }

  if (!isNullOrEmpty(param.order)) {
    const sortType =
      param.sortType === SORT_TYPE.asc.id
        ? SORT_TYPE.asc.name
        : SORT_TYPE.desc.name;
    searchParam.order = param.order + sortType;
  }

  if (param.isDistinct) {
    searchParam.distinct_worker = WORKER_DISTINCT_STATUS.distinct.id;
  }

  return _.omit(searchParam, blacklistSearchKeys);
};

const isSelectAllCheckbox = (state, initState) => {
  return !_.isEmpty(state) && _.size(state) === _.size(initState);
};

/**
 * 作業員設定データCSV出力
 * @param {*} blob blob形式
 * @param {number} fieldId 現場ID
 * */
const downloadCsv = (blob, fieldId) => {
  const csvBlob = new Blob([blob], { type: 'text/csv;charset=shift-jis;' });
  const filename = `作業員設定状況一覧_${fieldId}_${moment(new Date()).format(
    DATE_TIME_FORMAT.dateTimeMinuteFormat
  )}.csv`;
  PrintUtility.printBlob(csvBlob, filename);
};

/**
 * 作業員設定状況一覧画面で利用するビジネスロジック格納クラス
 * */
const WorkerSettingsService = {
  createSearchWorkerSettingList,
  downloadCsv,
};

export default WorkerSettingsService;



// WEBPACK FOOTER //
// ./src/services/workerSettings/WorkerSettingsService.js